import { Unless } from 'react-if';
import { OperationType } from '../../../../types';
import { AppliedPlan, PlanButtons } from '../components';
import { ManagePay } from '../manage';
import { usePlanSpaceDetailContext } from './PlanSpaceDetailProvider';
export const SubscribedPlanTemplate = () => {
  const {
    spacePlan
  } = usePlanSpaceDetailContext();
  // 결제관리탭이 숨겨져야하는 조건
  const shouldHideManagePay = !spacePlan || spacePlan?.operationType === OperationType.일시납 || spacePlan?.operationType === OperationType.커스텀_일시납 || spacePlan?.status === 'EXPIRED';
  return <>
      <AppliedPlan data-sentry-element="AppliedPlan" data-sentry-source-file="SubscribedPlanTemplate.tsx" />
      <Unless condition={shouldHideManagePay} data-sentry-element="Unless" data-sentry-source-file="SubscribedPlanTemplate.tsx">
        <ManagePay data-sentry-element="ManagePay" data-sentry-source-file="SubscribedPlanTemplate.tsx" />
      </Unless>
      <PlanButtons data-sentry-element="PlanButtons" data-sentry-source-file="SubscribedPlanTemplate.tsx" />
    </>;
};